import React from 'react'

class Home extends React.Component {
    constructor(props){
        super(props)
        this.state = {
            
        }
    }

    continue(){
        this.props.setStatus("quiz")
    }

    render(){
        return (
            <div className="container">
                <div className="row">
                    <div className="col-md-4"></div>
                    <div className="col-md-4 containBorder">
                        <div className="hero-unit">
                            <h1 className="bienvenue">Bienvenue</h1>
                            <img src="./assets/whatyouwant.gif" className="img-fluid" alt="best cat" />
                            <p className="Align">INSERER PHRASE DE BIENVENUE POUR FAIRE LE TESTE</p>
                            <p>
                                <div className="Align">
                                   <button type="button" onClick={()=> this.continue()} className="btn btn-outline-success startBtn">Commencer</button>
                                </div>
                            </p>
                        </div>
                    </div>
                </div>
                <div className="col-md-4"></div>
            </div>
        )
    }
    //<button onClick={() => this.props.setStatus("end")}>skip</button>
}
export default Home


// WEBPACK FOOTER //
// ./src/components/home.js